import React from "react";
import { WarningIcon } from "./WarningIcon";
import "./styles.scss";

export type IProps = {
  initialText?: string;
  linkText?: string;
  linkUrl?: string;
  show: boolean;
};
const Banner: React.FunctionComponent<IProps> = ({
  initialText,
  linkText,
  linkUrl,
  show,
}: IProps) => (show ? (
  <div data-testid="top-banner" className="banner">
    <div className="banner-contents">
      <div className="banner-icon-container">
        <WarningIcon />
      </div>
      <span className="banner-text">
        {initialText}
        {" "}
        { linkUrl ? <a href={linkUrl}>{linkText}</a> : "" }
      </span>
    </div>
  </div>
) : null);

export default Banner;
